/**
 * Hooks up controls for the header menu
 */
export const headerMenu = (): void => {
  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  const headerElement = document.querySelector('.js-header') as unknown as HTMLElement

  const summonElement = document.querySelector('.js-headerController') as unknown as HTMLElement

  const dismissElement = document.querySelector('.js-headerHider') as unknown as HTMLElement

  const allSubMenus = document.querySelectorAll('.js-headerMenuItem.-hasCarret') as unknown as HTMLElement[]

  summonElement.addEventListener('click', () => {
    bodyElement.classList.add('menuPopupPhone--opened')
  })

  dismissElement.addEventListener('click', () => {
    bodyElement.classList.remove('menuPopupPhone--opened')
  })

  if (allSubMenus) {
    allSubMenus.forEach(subMenu => {
      const carretElement = subMenu.querySelector('.js-headerMenuCarret') as unknown as HTMLElement

      carretElement.addEventListener('click', () => {
        if (subMenu.classList.contains('submenu--opened')) {
          subMenu.classList.remove('submenu--opened')
        } else {
          subMenu.classList.add('submenu--opened')
        }
      })
    })
  }

  const allScrollLinks = document.querySelectorAll('.js-headerLink') as unknown as HTMLLinkElement[]

  allScrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      if (link.href.includes('#')) {
        const hash = link.href.split('#')[1]

        const targetElement = document.querySelector(`#${hash}`) as unknown as HTMLElement

        if (targetElement) {
          e.preventDefault()

          const offset = targetElement.offsetTop

          window.scroll({
            top: offset,
            behavior: 'smooth'
          })

          bodyElement.classList.remove('menuPopupPhone--opened')
        }
      }
    })
  })
}
